import { useToastMessages } from '../../hooks/useToastMessages';
import { useEffect } from 'react';
import { registerNotifier } from './toastBridge.jsx';

const NotifierRegistrar = () => {
  const toast = useToastMessages();

  useEffect(() => {
    registerNotifier(toast);
  }, [toast]);

  return null;
};

export default NotifierRegistrar;
